import cacheLs from "../cacheLs"

export default {
  setRefreshComponentObj (state, data) {
    state.refreshComponentObj = data
    cacheLs.set_refreshComponentObj(data)
  }
}
